module.exports = __webpack_public_path__ + "img/payment-success.ac6d39eb.svg";